/*    
<summary>
  This functional component "StoreCmsWorkingDays" allows store to change/delete/add images which are visible to customer.
</summary>
<returns>Returns JSX</returns>
*/
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import weekdayEnum from "../../../../constants/enums/weekday-enum";
import { useStore } from "../../../../contexts/store-provider";
import { formatMessage } from "../../../../translations/format-message";
import AddWorkingDaysPopupHOC from "../hoc/cms-working-days-popup-hoc";
import AddEditCmsWorkingDays from "./add-edit-cms-working-days";

interface IProps {
  storeDetails: any;
}

const StoreCmsWorkingDays = (props: any) => {
  const { storeCmsStore } = useStore();
  const {
    GetStoreCmsWorkingHoursByIdAnonymousService,
    getWorkingHoursSettingDetail,
  } = storeCmsStore;
  const openAddWorkingDaysHandler = (values: any) => {
    props.addWorkingDaysPopupToggleHandler();
  };

  const addWorkingDaysSubmitHandler = (values: any) => {
    props.addWorkingDaysPopupToggleHandler();
  };

  useEffect(() => {
    if (props.storeDetails.Id > 0) {
      GetStoreCmsWorkingHoursByIdAnonymousService(props.storeDetails?.Id);
    }
  }, [props.storeDetails]);

  return (
    <React.Fragment>
      {props.showAddWorkingDaysPopup && (
        <AddEditCmsWorkingDays
          id={getWorkingHoursSettingDetail.Id}
          storeId={props.storeDetails.Id}
          modalClosed={props.addWorkingDaysPopupToggleHandler}
          submitHandler={addWorkingDaysSubmitHandler}
        />
      )}
      <div className="card h-100">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="card-title mb-0">
              <FormattedMessage id="store_hours" />
            </h4>
            <button
              className="btn btn-outline-primary"
              onClick={openAddWorkingDaysHandler}
            >
              <FormattedMessage id="edit" />
            </button>
          </div>
          {/* Additional CMS Details or Actions can be added here */}
          {getWorkingHoursSettingDetail?.Id > 0 ? (
            <React.Fragment>
              {getWorkingHoursSettingDetail?.BusinessSettings?.map(
                (hours: any) => {
                  return (
                    <div className="row mb-2 g-0">
                      <div className="col-5">
                        {hours.WeekDays == 7
                          ? formatMessage("public_holiday")
                          : hours.WeekDays == 8
                          ? formatMessage("holidays")
                          : formatMessage(weekdayEnum[hours.WeekDays])}
                      </div>
                      <div className="col-7">
                        {hours.IsClosed == true
                          ? <FormattedMessage id="closed" />
                          : `${hours.OpenTime} ~ ${hours.ClosedTime}`}
                      </div>
                    </div>
                  );
                }
              )}

              <div className="row mb-2 g-0">
                <div className="col-12"><FormattedMessage id="cms_store_holidays" /></div>
                <div className="col-12">
                  {getWorkingHoursSettingDetail?.HolidaysMessage}
                </div>
              </div>
            </React.Fragment>
          ) : (
            <p>
              <FormattedMessage id="NoRecordFound" />
            </p>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default AddWorkingDaysPopupHOC(observer(StoreCmsWorkingDays));
